var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLlms)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.fixWithAi}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" $vuetify.icons.ai ")]),_c('span',[_vm._v(_vm._s(_vm.$t('pattern.fixJsonWithAi')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }